export class OrganizationHeritageType {
  public id: string;
  public name: string;

  constructor(data: Partial<OrganizationHeritageType> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: any = {}): OrganizationHeritageType {
    return new OrganizationHeritageType({
      id: data?.id ?? '',
      name: data?.name ?? data?.title ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      title: this.name,
    };
  }
}
